import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/CircleGeometry'

export default meshComponent('Circle', props, createGeometry)
